__turbopack_context__.v({
  "label": "HotspotDebugOverlay-module-scss-module__rPckyW__label",
  "labelCopied": "HotspotDebugOverlay-module-scss-module__rPckyW__labelCopied",
  "overlay": "HotspotDebugOverlay-module-scss-module__rPckyW__overlay",
  "toggle": "HotspotDebugOverlay-module-scss-module__rPckyW__toggle",
});
